import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  FormHelperText,
  Input,
  Select,
  Box,
  Flex,
  Image,
  Text,
  Button,
  Card,
  CardBody,
  SimpleGrid,
  Textarea,
  TableContainer,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableCaption,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
} from "@chakra-ui/react";
import axios from "axios";
import { useSelector } from "react-redux";

import "react-calendar/dist/Calendar.css";
import Calendar from "react-calendar";
import React, { useState, useEffect, useRef } from "react";

import toast from "react-hot-toast";
import { set } from "lodash";

const WaiterRegister = () => {
  const customerId = localStorage.getItem("customerId");
  const [waiter, setWaiter] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [editWaiterId, setEditWaiterId] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const cancelRef = useRef();
  console.log(customerId);

  const waiterData = async () => {
    try {
      const response = await axios.get(
        `https://api.rasoi.launchlysoftware.in/api/waiterList/${customerId}`,
      );
      setWaiter(response.data.waiterList);
    } catch (error) {
      //  toast.error(error.message);
    }
  };

  const [formData, setFormData] = useState({
    name: "",
    password: "",
    designation: "",
    address: "",
    phoneNo: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const validateForm = () => {
    const requiredFields = [
      "name",
      "password",
      "designation",
      "address",
      "phoneNo",
    ];

    for (const field of requiredFields) {
      if (!formData[field]) {
        return false;
      }
    }
    return true;
  };
  const openModal = (id) => {
    setDeleteItemId(id);
    setIsOpen(true);
  };

  const onClose = () => {
    setIsOpen(false);
    setDeleteItemId(null);
  };
  const handleDelete = async () => {
    try {
      const response = await axios.delete(
        `https://api.rasoi.launchlysoftware.in/api/waiterDelete/${customerId}/${deleteItemId}`,
      );
      toast.success(response.data.message);
      setIsOpen(false);
      setDeleteItemId(null);
      waiterData();
    } catch (error) {
      toast.error(error.message);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      toast.error("Please fill in all required fields.");
      return;
    }
    // Here you can send formData to your backend server or process it further

    // Reset form after submission

    setFormData({
      name: formData.name,
      phoneNo: formData.phoneNo,
      password: formData.password,
      address: formData.address,
      designation: formData.designation,
    });
  };
  const edit = (item) => {
    setIsEditing(true);
    setEditWaiterId(item._id);

    setFormData({
      name: item.name,
      phoneNo: item.phoneNo,
      password: item.password,
      address: item.address,
      designation: item.designation,
    });
  };
  useEffect(() => {
    waiterData();
  }, [customerId]);

  const save = async (e) => {
    if (!validateForm()) {
      toast.error("Please fill in all required fields.");
      return;
    }
    e.preventDefault();
    if (isEditing) {
      try {
        const response = await axios.put(
          `https://api.rasoi.launchlysoftware.in/api/waiterUpdate/${customerId}/${editWaiterId}`,
          {
            data: formData,
          },
        );
        toast.success(response.data.message);
        setIsEditing(false);
        setEditWaiterId(null);
        setFormData({
          name: "",
          phoneNo: "",
          password: "",
          address: "",
          designation: "",
          image: null,
        });
        window.location.reload();
      } catch (error) {
        toast.error("Failed to update waiter. Please try again later.");
      }
    } else {
      // Prepare form data for sending to backend

      try {
        const response = await axios.post(
          "https://api.rasoi.launchlysoftware.in/api/waiterRegister",
          {
            customerId: customerId,
            data: formData,
          },
        );
        console.log("Data Submitted: ", response.data);
        toast.success(response.data.message);
        setFormData({
          name: "",
          phoneNo: "",
          password: "",
          address: "",
          designation: "",
          image: null,
        });

        window.location.reload();
      } catch (error) {
        console.error("Error:", error);
        toast.error("Failed to bill room. Please try again later.");
      }
    }
  };

  return (
    <Box
      bg="#f7f7f7"
      p="4"
      color="black"
      width="100%"
      height="90vh"
      overflow="hidden"
      display="flex"
      flexDirection="column"
    >
      <FormControl isRequired onSubmit={handleSubmit}>
        <Box overflowY="auto" maxH="calc(50vh - 100px)" pr={2}>
          <SimpleGrid columns={3} spacing={4}>
            <Box
              display="flex"
              alignItems="center"
              boxShadow="md"
              borderRadius="8px"
              bg="white"
              p={3}
            >
              <FormLabel mb="0" minW="100px">
                Name
              </FormLabel>
              <Input
                bg="#FAFAFA"
                placeholder="Waiter Name"
                border="1px solid #ffe4d9"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                size="sm"
              />
            </Box>

            <Box
              display="flex"
              alignItems="center"
              boxShadow="md"
              borderRadius="8px"
              bg="white"
              p={3}
            >
              <FormLabel mb="0" minW="100px">
                Password
              </FormLabel>
              <Input
                bg="#FAFAFA"
                placeholder="Password"
                border="1px solid #ffe4d9"
                name="password"
                value={formData.password}
                onChange={handleInputChange}
                size="sm"
              />
            </Box>

            <Box
              display="flex"
              alignItems="center"
              boxShadow="md"
              borderRadius="8px"
              bg="white"
              p={3}
            >
              <FormLabel mb="0" minW="100px">
                Designation
              </FormLabel>
              <Input
                bg="#FAFAFA"
                placeholder="Designation"
                border="1px solid #ffe4d9"
                name="designation"
                value={formData.designation}
                onChange={handleInputChange}
                size="sm"
              />
            </Box>

            <Box
              display="flex"
              alignItems="center"
              boxShadow="md"
              borderRadius="8px"
              bg="white"
              p={3}
            >
              <FormLabel mb="0" minW="100px">
                Phone No
              </FormLabel>
              <Input
                bg="#FAFAFA"
                placeholder="Phone Number"
                border="1px solid #ffe4d9"
                name="phoneNo"
                value={formData.phoneNo}
                onChange={handleInputChange}
                size="sm"
              />
            </Box>

            <Box
              display="flex"
              alignItems="center"
              boxShadow="md"
              borderRadius="8px"
              bg="white"
              p={3}
              gridColumn="span 2"
            >
              <FormLabel mb="0" minW="100px">
                Address
              </FormLabel>
              <Input
                bg="#FAFAFA"
                placeholder="Address"
                border="1px solid #ffe4d9"
                name="address"
                value={formData.address}
                onChange={handleInputChange}
                size="sm"
              />
            </Box>
          </SimpleGrid>
        </Box>

        <Box mt={3} pb={2} display="flex" justifyContent="flex-end">
          <Button
            variant="solid"
            color="white"
            bg="#0F3D2E"
            _hover={{ color: "#0F3D2E", bg: "white" }}
            onClick={save}
          >
            {isEditing ? "Update" : "Save"}
          </Button>
        </Box>
      </FormControl>
      <TableContainer
        width="full"
        overflowY="auto"
        maxH="calc(50vh - 50px)"
        mt={4}
        border="1px solid black"
        p={4}
        bg="white"
        borderRadius="10px"
        fontSize="sm"
      >
        <Table size="sm" variant="striped" colorScheme="teal">
          <TableCaption>Item Data</TableCaption>
          <Thead>
            <Tr>
              <Th>Name</Th>
              <Th>designation</Th>
              <Th>Phone No</Th>
              <Th>Password</Th>
              <Th>Address</Th>

              <Th>Edit</Th>
              <Th>Delete</Th>
            </Tr>
          </Thead>
          <Tbody>
            {waiter.map((item, index) => (
              <Tr key={index}>
                <Td>{item.name}</Td>
                <Td>{item.designation}</Td>
                <Td>{item.phoneNo}</Td>
                <Td>{item.password}</Td>
                <Td>{item.address}</Td>

                <Td>
                  <Button
                    colorScheme="green"
                    size="sm"
                    onClick={() => edit(item)}
                  >
                    Edit
                  </Button>
                </Td>
                <Td>
                  <Button
                    colorScheme="red"
                    size="sm"
                    onClick={() => openModal(item._id)}
                  >
                    Delete
                  </Button>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Confirm Deletion
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure you want to delete this item?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancel
              </Button>
              <Button colorScheme="red" onClick={handleDelete} ml={3}>
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Box>
  );
};

export default WaiterRegister;
